<jhi-page-ribbon></jhi-page-ribbon>
<div>
  <router-outlet name="navbar"></router-outlet>
</div>
<div class="hipster  d-none d-md-block">
  <div class="logo_left   d-none d-md-block"></div>
</div>
<div class="hipster d-md-none">
  <div class="logo_center d-md-none"></div>
</div>
<div class="container-fluid">
  <div class="card jh-card">
    <router-outlet></router-outlet>
  </div>


</div>
<jhi-footer></jhi-footer>
